import React, { useState, useEffect } from "react";

/**
 * Componente para manejar imágenes de equipos con fallback automático
 * 
 * @param {string} src - URL de la imagen del logo del equipo
 * @param {string} alt - Texto alternativo para la imagen
 * @param {string} className - Clases CSS para aplicar al componente
 * @returns {JSX.Element} - Componente de logo con manejo de errores
 */
const TeamLogo = ({ src, alt, className = "" }) => {
  const [imageError, setImageError] = useState(false);

  // Resetear el estado cuando cambie la URL de la imagen
  useEffect(() => {
    setImageError(false);
  }, [src]);

  const handleError = (e) => {
    console.log("Error cargando imagen:", src);
    setImageError(true);
  };

  // Si no hay src o hay error, mostrar placeholder
  if (!src || imageError) {
    return (
      <div className={`${className} flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800`}>
        <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"/>
        </svg>
      </div>
    );
  }

  // Simplemente mostrar la imagen
  return (
    <img
      src={src}
      alt={alt || "Team logo"}
      className={className}
      onError={handleError}
    />
  );
};

export default TeamLogo;

